module.exports = __webpack_public_path__ + "img/dp.1bd10aae.png";